<template>
  <div class="buttons-container">
    <component :is="reference" :widget="widget" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Button from '@/shared/components/Button'

export default {
  name: 'WidgetSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.panel.widget-side-nav' },
  components: { Button },
  props: {
    parentId: {
      type: String,
      default: '',
    },
    widget: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    reference() {
      return () => import(`@/components/sidenav/landing/panel/${this.widget.type}SideNav.vue`)
    },
  },
  methods: {
    ...mapActions('landing', ['removeWidget']),
    ...mapActions('ui', ['scrollIntoView']),
    scrollToComponent(widget) {
      this.scrollIntoView(widget.id)
    },
  },
}
</script>
